import { useState } from "react";
import { FiMail } from "react-icons/fi";
import api from "../services/api";

const ChangeEmail = () => {
  const [formData, setFormData] = useState({
    current_password: "",
    new_email: "",
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitErrors, setSubmitErrors] = useState([]);
  const [submitSuccess, setSubmitSuccess] = useState("");

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setIsSubmitting(true);
    setSubmitErrors([]);
    setSubmitSuccess("");

    try {
      const token = localStorage.getItem("rmc2.access_token");
      if (!token) {
        setSubmitErrors(["Missing access token."]);
        return;
      }

      const response = await api.post("/change-email", formData, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (response.data?.status !== "success") {
        const message = response.data?.message || "Failed to request email change.";
        if (message && typeof message === "object") {
          const flattened = Object.values(message).flat();
          setSubmitErrors(flattened);
        } else {
          setSubmitErrors([message]);
        }
        return;
      }

      setSubmitSuccess(response.data?.message || "Verification email sent.");
      setFormData({
        current_password: "",
        new_email: "",
      });
    } catch (error) {
      const message = error?.response?.data?.message;
      if (message && typeof message === "object") {
        const flattened = Object.values(message).flat();
        setSubmitErrors(flattened);
      } else if (typeof message === "string") {
        setSubmitErrors([message]);
      } else {
        setSubmitErrors(["Failed to request email change."]);
      }
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="mx-auto flex w-full max-w-[1400px] flex-col gap-6">
      <div className="rounded-3xl border border-white/60 bg-white/90 p-6 shadow-lg shadow-slate-200/60">
        <p className="text-xs font-semibold uppercase tracking-[0.3em] text-slate-400">
          Security
        </p>
        <h1 className="mt-3 text-3xl font-semibold text-slate-900">
          Change Email
        </h1>
        <p className="mt-2 text-sm text-slate-500">
          Verify your current password to update your email address.
        </p>
      </div>

      <div className="rounded-3xl border border-white/60 bg-white/90 p-6 shadow-lg shadow-slate-200/60">
        <div className="flex items-center gap-3">
          <div className="flex h-11 w-11 items-center justify-center rounded-2xl bg-blue-100 text-[var(--brand-blue)]">
            <FiMail />
          </div>
          <div>
            <p className="text-xs font-semibold uppercase tracking-[0.3em] text-slate-400">
              Email
            </p>
            <h2 className="text-2xl font-semibold text-slate-900">
              Update Email
            </h2>
          </div>
        </div>

        <form onSubmit={handleSubmit} className="mt-6 space-y-5">
          <div className="space-y-2">
            <label className="text-xs font-semibold text-slate-500">
              Current Password
            </label>
            <input
              type="password"
              name="current_password"
              value={formData.current_password}
              onChange={handleChange}
              placeholder="Current Password"
              className="w-full rounded-2xl border border-slate-200 bg-white px-4 py-3 text-sm text-slate-700 placeholder:text-slate-400 focus:border-blue-400 focus:outline-none focus:ring-2 focus:ring-blue-200"
            />
          </div>

          <div className="space-y-2">
            <label className="text-xs font-semibold text-slate-500">
              New Email
            </label>
            <input
              type="email"
              name="new_email"
              value={formData.new_email}
              onChange={handleChange}
              placeholder="New Email"
              className="w-full rounded-2xl border border-slate-200 bg-white px-4 py-3 text-sm text-slate-700 placeholder:text-slate-400 focus:border-blue-400 focus:outline-none focus:ring-2 focus:ring-blue-200"
            />
          </div>

          {submitErrors.length > 0 && (
            <div className="rounded-2xl border border-rose-100 bg-rose-50 px-4 py-3 text-sm text-rose-600">
              <ul className="space-y-1">
                {submitErrors.map((item, index) => (
                  <li key={`${item}-${index}`}>{item}</li>
                ))}
              </ul>
            </div>
          )}
          {submitSuccess && (
            <div className="rounded-2xl border border-emerald-100 bg-emerald-50 px-4 py-3 text-sm text-emerald-600">
              {submitSuccess}
            </div>
          )}

          <div className="flex justify-end">
            <button
              type="submit"
              disabled={isSubmitting}
              className="rounded-2xl bg-[var(--brand-orange)] px-6 py-3 text-sm font-semibold text-white shadow-lg shadow-orange-200 transition hover:bg-[var(--brand-orange-dark)]"
            >
              {isSubmitting ? "Sending..." : "Send Verification"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ChangeEmail;
